import { useTranslation } from 'react-i18next';

const features = [
  {
    key: 'price',
    image: 'https://readdy.ai/api/search-image?query=Modern%20minimal%20desk%20setup%20with%20a%20laptop%20showing%20colorful%20price%20comparison%20charts%20and%20graphs%2C%20warm%20ambient%20lighting%20from%20a%20desk%20lamp%2C%20notebook%20and%20coffee%20cup%20nearby%2C%20clean%20workspace%20aesthetic%2C%20soft%20cream%20walls%2C%20professional%20home%20office%20photography&width=800&height=1000&seq=feat-price-v2-p7q1&orientation=portrait',
    icon: 'ri-money-dollar-circle-line',
  },
  {
    key: 'quality',
    image: 'https://readdy.ai/api/search-image?query=Close%20up%20macro%20shot%20of%20premium%20woven%20fabric%20texture%20with%20a%20magnifying%20glass%20resting%20beside%20it%2C%20warm%20natural%20light%20from%20a%20nearby%20window%2C%20wooden%20surface%20with%20soft%20reflections%2C%20artisan%20quality%20inspection%20scene%2C%20rich%20textile%20details%20visible%2C%20minimal%20composition&width=800&height=1000&seq=feat-quality-v2-r8s2&orientation=portrait',
    icon: 'ri-shield-check-line',
  },
  {
    key: 'guide',
    image: 'https://readdy.ai/api/search-image?query=Open%20leather%20bound%20notebook%20with%20handwritten%20notes%20and%20a%20smartphone%20displaying%20a%20shopping%20interface%20on%20a%20minimal%20desk%2C%20warm%20daylight%20from%20a%20window%2C%20small%20succulent%20plant%20nearby%2C%20cozy%20learning%20environment%2C%20soft%20beige%20and%20cream%20tones%2C%20lifestyle%20education%20photography&width=800&height=1000&seq=feat-guide-v2-t9u3&orientation=portrait',
    icon: 'ri-book-open-line',
  },
  {
    key: 'safety',
    image: 'https://readdy.ai/api/search-image?query=Modern%20security%20shield%20icon%20rendered%20in%20warm%20metallic%20copper%20tone%20on%20a%20minimal%20light%20background%2C%20soft%20gradient%20lighting%2C%20clean%203D%20render%20style%2C%20trust%20and%20protection%20concept%2C%20sophisticated%20corporate%20aesthetic%2C%20subtle%20reflections%20and%20smooth%20surfaces&width=800&height=1000&seq=feat-safety-v2-u4v5&orientation=portrait',
    icon: 'ri-lock-line',
  },
];

const cardWidths = ['lg:col-span-3', 'lg:col-span-4', 'lg:col-span-3', 'lg:col-span-2'];

export default function FeatureSection() {
  const { t } = useTranslation();

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <h2 className="font-heading text-4xl md:text-5xl text-foreground-900">
            {t('features.heading')}
          </h2>
          <span className="inline-block mt-2 text-2xl">📊</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-5">
          {features.map((feature, index) => (
            <div
              key={feature.key}
              className={`group relative rounded-2xl overflow-hidden transition-all duration-300 hover:scale-[1.01] ${cardWidths[index]}`}
              style={{ aspectRatio: '3/4' }}
            >
              <img
                src={feature.image}
                alt={t(`features.${feature.key}_title`)}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                <div className="flex items-center gap-3 mb-2">
                  <span className="w-10 h-10 rounded-full bg-primary-500/90 flex items-center justify-center">
                    <i className={`${feature.icon} text-white text-lg`}></i>
                  </span>
                  <h3 className="font-heading text-2xl md:text-3xl text-white font-semibold">
                    {t(`features.${feature.key}_title`)}
                  </h3>
                </div>
                <p className="text-white/80 text-sm md:text-base leading-relaxed max-w-md opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  {t(`features.${feature.key}_desc`)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}